/* --------------------
 * is-class-component module
 * ESM Entry point
 * ------------------*/

// Imports
import isClassComponent from '../dist/esm/is-class-component.js';

// Exports

export default isClassComponent;
